<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon> {{label.reportType}}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md6 lg6>
                        <v-autocomplete :items="reportTypes" v-model="form.reportType" :label="label.reportType" item-text="label" item-value="value" data-vv-name="reportType" :data-vv-as="label.reportType" :error-messages="errors.collect('reportType')" v-validate="'required'"></v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm6 md6 lg6>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12>
          <div v-if="form.reportType === 'prodStats'">
            <ProdStats></ProdStats>
          </div>
          <div v-if="form.reportType === 'prodExecAgent'">
            <ProdExecAgent></ProdExecAgent>
          </div>
          <div v-if="form.reportType === 'prodExecPolTypeGrp'">
            <ProdExecPolTypeGrp></ProdExecPolTypeGrp>
          </div>
          <div v-if="form.reportType === 'agentProd'">
            <AgentProd></AgentProd>
          </div>
          <div v-if="form.reportType === 'wrkStat'">
           <ProdWkStats></ProdWkStats>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import ProdStats from './ProdStats'
import ProdExecAgent from './ProdExecAgent'
import ProdExecPolTypeGrp from './ProdExecPolTypeGrp'
import AgentProd from './AgentProd'
import ProdWkStats from './ProdWkStats'

export default {
  data() {
    return {
      label: {
        reportType: 'Report Type'
      },
      form: {
        reportType: 'prodStats'
      },
      reportTypes: [
        { label: 'Productivity Statistics by Source', value: 'prodStats' },
        { label: 'Productivity by Executive/Agent', value: 'prodExecAgent' },
        { label: 'Productivity by Executive/Policy Type Group', value: 'prodExecPolTypeGrp' },
        { label: 'Agents Productivity', value: 'agentProd' },
        { label: 'Work statistics', value: 'wrkStat' }
      ],
      panel: [0]
    }
  },
  methods: {
    async doInit() {
      if (this.$store.state.reports.uwReports.init !== 1) {
        await this.$store.dispatch('uwReportsInit')
      }
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    ProdStats,
    ProdExecAgent,
    ProdExecPolTypeGrp,
    AgentProd,
    ProdWkStats
  }
}
</script>

<style>

</style>
